import { createSagaActionTypes } from '../../../utils/actionFactory';

export const GET_DATA_LIMITS = 'GET_DATA_LIMITS';
export const DELETE_DATALIMIT = 'DELETE_DATALIMIT';

export const actions = createSagaActionTypes('DATA_LIMITS', [
  GET_DATA_LIMITS,
  DELETE_DATALIMIT
]);
